module.exports = __webpack_public_path__ + "img/party-2012-zunyi.f4e48ad9.jpg";